import { Url } from 'next/dist/shared/lib/router/router';
import { useRouter } from 'next/router';

import { LinkFragmentFragment } from '../../../../__generated__/graphql';
import { Heading6, TextLink } from '../../../../components/Text';
import { convertHref } from '../../../../utils/convertHref';
import { removeTrailingSlash } from '../../../../utils/removeTrailingSlash';
import { sanitizeHtml } from '../../../../utils/sanitzeHtml';

import style from './mobile-nav-link-list.module.css';

export interface MobileNavLinkListItem {
  href: Url;
  label: string;
}

interface MobileNavLinkListProps {
  items: MobileNavLinkListItem[];
  onClickActive: () => void;
  sectionTitle?: null | string;
}

// A couple of items use dangerouslySetInnerHTML. The API returns HTML entities
// that need to be converted to HTML.
const MobileNavLinkList = ({
  items,
  onClickActive,
  sectionTitle,
}: MobileNavLinkListProps) => {
  const router = useRouter();

  return (
    <div className={style.menuLinksSection}>
      {sectionTitle && (
        <Heading6
          // eslint-disable-next-line @typescript-eslint/naming-convention
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(sectionTitle) }}
          fontSizeOverride={14}
          uppercase
        />
      )}

      <ul>
        {items.map(item => {
          const linkFragment: LinkFragmentFragment = {
            title: item.label,
            url: item.href as string,
          };

          const isActive = removeTrailingSlash(convertHref(item.href))
            === removeTrailingSlash(router.asPath);

          return (
            <li key={item.label}>
              <TextLink
                // eslint-disable-next-line @typescript-eslint/naming-convention
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.label) }}
                fontSize={16}
                linkFragment={linkFragment}
                onClick={isActive ? onClickActive : undefined}
                underlined
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileNavLinkList;
